module.exports = __webpack_public_path__ + "media/react/features/event-creation-wizard/assets/templates/meetup-99b31a509cadb02a08e0771dfa9c812b.png";